function toggleMenuVardo() {
    const drawerVardo = document.getElementById("menu-vardo-drawer");
    const overlayVardo = document.getElementById("menu-vardo-overlay");

    const isOpening = !drawerVardo.classList.contains("active");

    drawerVardo.classList.toggle("active");
    overlayVardo.classList.toggle("active");
    document.documentElement.classList.add("no-scroll");

    // Si se está abriendo el menú → cargar imágenes
    if (isOpening) {
        const lazyImages = drawerVardo.querySelectorAll("img[data-src]");
        lazyImages.forEach((img) => {
            if (!img.src) {
                img.src = img.dataset.src;
            }
        });
    }
}

function closeMenuVardo() {
    const drawerVardo = document.getElementById("menu-vardo-drawer");
    const subMenuVardo = document.querySelector(".menu-vardo-submenu.active");
    const productView = document.querySelector(
        ".menu-vardo-product-view.active",
    );
    const overlayVardo = document.querySelector(".menu-vardo-overlay.active");
    document.documentElement.classList.remove("no-scroll");

    if (productView) {
        productView.classList.remove("active");
    }
    if (subMenuVardo) {
        subMenuVardo.classList.remove("active");
    }
    drawerVardo.classList.remove("active");
    overlayVardo.classList.remove("active");
}
function openSubmenuVardo(index) {
    // Ocultar todos los submenús
    document.querySelectorAll(".menu-vardo-submenu").forEach((el) => {
        el.classList.remove("active");
    });

    // Activar el submenú correcto
    const submenu = document.querySelector(
        `.menu-vardo-submenu[data-parent="${index}"]`,
    );
    if (submenu) {
        submenu.classList.add("active");

        // 🔹 Espera un poco antes de cargar imágenes (ej. 300ms)
        setTimeout(() => {
            submenu.querySelectorAll("img[data-src]").forEach((img) => {
                if (!img.src) {
                    img.src = img.dataset.src;
                }
            });
        }, 300); // ajusta al mismo tiempo que tu animación CSS
    }
}

function closeSubmenuVardo() {
    document.querySelectorAll(".menu-vardo-submenu").forEach((el) => {
        el.classList.remove("active");
    });
}

function openProductViewVardo(parentIndex, childIndex, handle) {
    // Cerramos todos los product views
    document.querySelectorAll(".menu-vardo-product-view").forEach((el) => {
        el.classList.remove("active");
    });

    // Seleccionamos el que corresponde abrir
    const productView = document.querySelector(
        `.menu-vardo-product-view[data-parent="${parentIndex}"][data-child="${childIndex}"][data-handle="${handle}"]`,
    );

    if (productView) {
        productView.classList.add("active");

        // Lazy-load imágenes
        const images = productView.querySelectorAll(
            ".menu-drawer__inner-submenu-product-slider-image",
        );
        images.forEach((img) => {
            if (!img.src) {
                img.src = img.dataset.src;
            }
        });
    }
}

function closeProductViewVardo() {
    document.querySelectorAll(".menu-vardo-product-view").forEach((el) => {
        el.classList.remove("active");
    });
}

document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
        closeMenuVardo();
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const fieldsets = document.querySelectorAll("fieldset");
    fieldsets.forEach((fieldset) => {
        const productContainerMenu = fieldset.closest(
            ".menu-drawer__inner-submenu-product",
        );
        if (!productContainerMenu) return;

        const initialColor = productContainerMenu.dataset.initialColor;
        if (!initialColor) return;

        const matchingSwatch = fieldset.querySelector(
            `.swatch-button-{{ section.id }}[data-color="${initialColor}"]`,
        );

        if (matchingSwatch) {
            matchingSwatch.classList.add("active");

            const image = matchingSwatch.dataset.image;
            const bg = productContainerMenu.querySelector(
                ".menu-drawer__inner-submenu-product-slider-image",
            );
            if (image && bg) {
                bg.src = image;
            }

            // Cambia el título inicial
            const title = productContainerMenu.querySelector(
                ".menu-drawer__inner-submenu-product-container p",
            );
            if (title && initialColor) {
                const originalTitle = title.textContent.split(" - ")[0];
                title.textContent = `${originalTitle} - ${initialColor}`;
            }
        } else {
            // fallback: activar el primero
            const first = fieldset.querySelector(
                ".swatch-button-{{ section.id }}",
            );
            if (first) {
                first.classList.add("active");

                const image = first.dataset.image;
                const color = first.dataset.color;
                const bg = productContainerMenu.querySelector(
                    ".menu-drawer__inner-submenu-product-slider-image",
                );
                if (image && bg) {
                    bg.src = image;
                }

                const title = productContainerMenu.querySelector(
                    ".menu-drawer__inner-submenu-product-container p",
                );
                if (title && color) {
                    const originalTitle = title.textContent.split(" - ")[0];
                    title.textContent = `${originalTitle} - ${color}`;
                }
            }
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const menuDrawer = document.querySelector(".menu-drawer");
    const images = menuDrawer.querySelectorAll("img[data-src]");

    function loadMenuImages() {
        images.forEach((img) => {
            if (!img.getAttribute("src")) {
                img.setAttribute("src", img.dataset.src);
            }
        });
    }

    // Ejemplo: si tu menú abre con una clase "open"
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (
                mutation.attributeName === "class" &&
                menuDrawer.classList.contains("open")
            ) {
                loadMenuImages();
            }
        });
    });

    observer.observe(menuDrawer, { attributes: true });
});
